export const userInfoMockResponse = {
  id: '1721c50a-2249-4cd0-a4a5-80301913107e',
  email: 'tibor.suty@carvago.com',
  blocked: false,
  external: false,
  roles: [
    {
      id: 'b4af42ee-f314-4284-a70c-dc0d5808b6bb',
      title: 'MANAGER',
    },
  ],
  branches: [
    {
      id: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
      name: 'Brno  - Test',
      street: 'Náchodská 20',
      number: '',
      city: 'Praha',
      zip: '19300',
      country: 'CZE',
    },
    {
      id: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
      name: 'Brno - Teas - Ford',
      street: 'Platnéřská 88/9',
      number: '',
      city: 'Praha 1',
      zip: '11000',
      country: 'CZE',
    },
    {
      id: 'e0e303be-87ec-4bbd-96a2-7e50a6bc0ffb',
      name: 'JHJHJ',
      street: 'LLL 22',
      number: '',
      city: 'Praha',
      zip: '1100',
      country: 'CZE',
    },
    {
      id: 'f01fce3d-db81-4323-94d8-383991101ca2',
      name: 'string',
      street: 'string',
      number: '',
      city: 'string',
      zip: 'string',
      country: 'CZE',
    },
  ],
  firstName: 'Tibor',
  lastName: 'Šutý',
  phoneNumber: null,
  isAway: false,
  awayChangedAt: null,
  state: 'onboarded',
  defaultBranch: {
    id: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
    name: 'Brno  - Test',
    street: 'Náchodská 20',
    number: '',
    city: 'Praha',
    zip: '19300',
    country: 'CZE',
  },
};
